// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProducerLocation_wrapper__FxLPM","boxed":"ProducerLocation_boxed__3CxE2","energy":"ProducerLocation_energy__zKbZU","location":"ProducerLocation_location__x19_E"};